import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TicketOutlineIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TicketOutlineIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M14.9152 19.3634H3.82087C3.06516 19.3634 2.4502 18.7485 2.4502 17.9932V16.9389C2.4502 16.3131 2.87978 15.7649 3.49475 15.607C4.01015 15.4745 4.37011 15.0096 4.37011 14.4771C4.37011 13.9445 4.01015 13.4796 3.49475 13.3472C2.87979 13.1893 2.4502 12.642 2.4502 12.0162V10.7579C2.4502 10.0017 3.06515 9.38673 3.82087 9.38673H11.2416C11.4696 9.38673 11.6859 9.48971 11.8286 9.66821C11.9718 9.84574 12.0262 10.0792 11.9772 10.3018C11.7658 11.263 11.0587 12.0172 10.121 12.2919V13.1069H13.7338C13.9766 13.1069 14.2046 13.2236 14.3458 13.4208C14.4876 13.6179 14.5253 13.8719 14.4473 14.1014C14.4061 14.224 14.3851 14.3496 14.3851 14.4771C14.3851 15.0057 14.7416 15.4696 15.2521 15.605C15.8612 15.7668 16.2858 16.3131 16.2858 16.933V17.9932C16.2858 18.7484 15.6709 19.3634 14.9152 19.3634ZM3.95671 17.8569H14.7793V17.036C13.6995 16.7113 12.9394 15.7374 12.882 14.6134H9.98519C9.22949 14.6134 8.61452 13.9984 8.61452 13.2432V12.1879C8.61452 11.6033 8.98919 11.0874 9.5404 10.8932H3.95671V11.9123C5.09149 12.2438 5.87663 13.2864 5.87663 14.4771C5.87663 15.6678 5.09149 16.7104 3.95671 17.0419V17.8569Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.08 14.6134H13.7338C13.4911 14.6134 13.263 14.4967 13.1213 14.2986C12.9801 14.1014 12.9423 13.8474 13.0208 13.6179C13.3003 12.796 13.954 12.1663 14.7794 11.9182V10.8932H11.2411C11.0131 10.8932 10.7968 10.7893 10.6541 10.6117C10.5109 10.4342 10.4565 10.2008 10.5055 9.97815C10.5251 9.88988 10.5345 9.80749 10.5345 9.72707C10.5345 9.1945 10.1745 8.7296 9.65909 8.59719C9.04414 8.43927 8.61454 7.89102 8.61454 7.26526V6.0069C8.61454 5.25169 9.2295 4.63672 9.98521 4.63672H21.08C21.8357 4.63672 22.4502 5.25168 22.4502 6.0069V7.27115C22.4502 7.89102 22.0255 8.43732 21.4174 8.59915C20.9074 8.73451 20.5499 9.19842 20.5499 9.72708C20.5499 10.2557 20.9064 10.7196 21.4164 10.855C22.0245 11.0149 22.4502 11.5612 22.4502 12.183V13.2432C22.4502 13.9985 21.8357 14.6134 21.08 14.6134ZM15.7469 13.1069H20.9437V12.286C19.8197 11.9466 19.0434 10.9079 19.0434 9.72707C19.0434 8.54619 19.8202 7.50654 20.9437 7.16816V6.14323H10.121V7.16228C11.1465 7.4624 11.886 8.3412 12.0194 9.38673H14.9152C15.6709 9.38673 16.2859 10.0017 16.2859 10.7579V12.0211C16.2859 12.4547 16.0789 12.8519 15.7469 13.1069Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default TicketOutlineIcon;
